(() => {
 const shell=document.querySelector('.lp-exact-desktop');
 if(!shell)return;
 const canvas=shell.querySelector('.lp-exact-canvas');
 const contentWidth=()=>Math.min(innerWidth-64,1200);
 const desktopScale=()=>contentWidth()/1920;
 const scale=()=>{if(innerWidth>=750){shell.style.setProperty('--lp-exact-scale',String(desktopScale()));shell.style.setProperty('--lp-content-width',contentWidth()+'px');const hero=canvas.querySelector('[data-node-id="285:721"] img');hero.loading='eager';hero.fetchPriority='high';}};
 scale();addEventListener('resize',scale,{passive:true});
 const compactY=y=>y-(y>=10151?505:0)-(y>=16191?220:0)-(y>=24717?800:0);
 const jump=y=>scrollTo({top:shell.getBoundingClientRect().top+scrollY+compactY(y)*desktopScale(),behavior:'instant'});
 const bind=(element,label,action)=>{
  element.setAttribute('role','link');element.setAttribute('tabindex','0');element.setAttribute('aria-label',label);element.style.cursor='pointer';
  element.addEventListener('click',action);
  element.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();action();}});
 };
 canvas.querySelectorAll('p').forEach(text=>{
  const label=text.textContent.trim();
  if(label==='Quero provar a Dates')bind(text.parentElement,label,()=>{
   if(text.parentElement.dataset.nodeId==='299:127'){
    const href=document.querySelector('.lp-kit-btn')?.href;
    if(href)location.assign(href);
   }else jump(22247);
  });
  if(label==='Pegar meu código')bind(text.parentElement,label,()=>{const href=document.querySelector('.lp-of-primeira-compra a')?.href;if(href)location.assign(href);});
  if(label==='Não sei qual sabor escolher'||label==='Descobrir meu sabor em 1 minuto')bind(text.parentElement,label,()=>{const href=document.querySelector('.lp-hero-link')?.href;if(href)location.assign(href);});
 });
 const flavorLinks=[...document.querySelectorAll('.lp-sab-card-btn')];
 [...canvas.querySelectorAll('p')].filter(p=>p.textContent.trim()==='Quero esse').forEach((p,i)=>bind(p.parentElement,'Escolher sabor',()=>{if(flavorLinks[i])location.assign(flavorLinks[i].href);}));
 const offerLinks=[...document.querySelectorAll('.lp-of-tier-btn')];
 [...canvas.querySelectorAll('p')].filter(p=>p.textContent.trim()==='Quero provar').forEach((p,i)=>bind(p.parentElement,'Escolher kit',()=>{if(offerLinks[i])location.assign(offerLinks[i].href);}));
 const gallery=canvas.querySelector('[data-node-id="285:907"]');
 if(gallery){
  gallery.setAttribute('role','group');gallery.setAttribute('aria-label','Fotos da textura da Dates');
 }
 const tabDefinitions=[['285:912','dark'],['285:930','red'],['285:911','just'],['285:910','pistache'],['285:909','coco']];
 const tabs=tabDefinitions.map(([id,flavor])=>({element:canvas.querySelector(`[data-node-id="${id}"]`),flavor}));
 const panel=canvas.querySelector('[data-node-id="285:932"]');
 const title=canvas.querySelector('[data-node-id="285:934"]');
 const ingredients=canvas.querySelector('[data-node-id="285:936"]');
 const picture=canvas.querySelector('[data-node-id="285:937"] img');
 const background=canvas.querySelector('[data-node-id="285:933"]');
 const selectFlavor=(flavor,animate=true)=>{
  const source=document.querySelector(`.lp-ingredientes [data-ing-card="${flavor}"]`);if(!source)return;
  tabs.forEach(tab=>{const selected=tab.flavor===flavor;tab.element.setAttribute('aria-selected',String(selected));tab.element.tabIndex=selected?0:-1;});
  title.textContent=source.querySelector('.lp-ing-card-nome').textContent;
  ingredients.replaceChildren(...[...source.querySelectorAll('.lp-ing-lista li')].map(item=>{const li=document.createElement('li');li.style.marginInlineStart='60px';const span=document.createElement('span');span.style.lineHeight='1.62';span.textContent=item.textContent;li.append(span);return li;}));
  const img=source.querySelector('.lp-ing-card-foto img');picture.src=img.getAttribute('src');picture.alt=img.alt;
  background.style.background=source.style.background;
  panel.dataset.flavor=flavor;
  if(animate){panel.classList.remove('lp-switching');void title.offsetWidth;panel.classList.add('lp-switching');}
 };
 tabs.forEach((tab,index)=>{
  tab.element.setAttribute('role','tab');tab.element.setAttribute('aria-label',tab.flavor);tab.element.setAttribute('aria-controls','lp-desktop-ingredients');tab.element.tabIndex=index===0?0:-1;
  tab.element.addEventListener('click',()=>selectFlavor(tab.flavor));
  tab.element.addEventListener('keydown',event=>{
   if(event.key==='Enter'||event.key===' '){event.preventDefault();selectFlavor(tab.flavor);return;}
   if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
   event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;selectFlavor(tabs[next].flavor);tabs[next].element.focus();
  });
 });
 panel.id='lp-desktop-ingredients';panel.setAttribute('role','tabpanel');
 // Read the existing data without triggering or modifying mobile's controls.
 selectFlavor('dark',false);
 bind(canvas.querySelector('[data-node-id="285:84"]'),'Dates — início',()=>location.assign('/'));
 bind(canvas.querySelector('[data-node-id="285:79"]'),'Abrir menu',()=>{
  const old=canvas.querySelector('.lp-exact-menu');if(old){old.remove();return;}
  const menu=document.createElement('nav');menu.className='lp-exact-menu';menu.setAttribute('aria-label','Menu Dates');
  for(const [label,action] of [['Nossos sabores',()=>jump(21197)],['Escolher meu kit',()=>jump(22247)],['Contato',()=>location.assign('https://wa.me/554732025529?text=Oi%21')]]){
   const a=document.createElement('a');a.textContent=label;a.href='#';a.addEventListener('click',e=>{e.preventDefault();menu.remove();action();});menu.append(a);
  }
  canvas.append(menu);
 });
})();
